export default __webpack_public_path__ + "static/Крысиные бега_10-6419f606871ded37ffbe56de8fce4679.jpg";